import { useAssetUpload } from '@/hooks/useAssetUpload';
import { ReactNode } from 'react';
import { AssetUploadContext } from './AssetUploadContext';

export const AssetUploadProvider = ({ children }: { children: ReactNode }) => {
  const uploadState = useAssetUpload();

  return <AssetUploadContext.Provider value={uploadState}>{children}</AssetUploadContext.Provider>;
};
